import { render, staticRenderFns } from "./EmergencyprocessForm.vue?vue&type=template&id=9d8c59f6"
import script from "./EmergencyprocessForm.vue?vue&type=script&lang=js"
export * from "./EmergencyprocessForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports